// @ts-strict-ignore
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lm-pending-changes-form',
  template: `
      <p>{{documentHasChangesMessage}}</p>
      <p>{{clickApply}}</p>
      <p>{{clickDiscard}}</p>
  `
})

export class LMPendingChangesDialogComponent implements OnInit, AfterViewInit {
  @Input() formSpec: LMFormSpec;
  @Input() formOptions: LMFormOptions;

  public documentHasChangesMessage: string;
  public clickApply: string;
  public clickDiscard: string;

  constructor() {
  }

  ngOnInit() {
    this.documentHasChangesMessage = Soho.Locale.translate('DocumentHasPendingChangesMessage');
    this.clickApply = Soho.Locale.translate('ClickApplyToContinueChanges');
    this.clickDiscard = Soho.Locale.translate('ClickDiscardToIgnoreChanges');
  }

  ngAfterViewInit() {
  }
}
